export default __webpack_public_path__ + "e877985a81e8d644545dead04ba11e8e.png";